import { useState, useEffect, useCallback } from "react";
import api from "./appelApi";

export default function AdminPanel({ user, onClose }) {
  const [users, setUsers] = useState([]);
  const [nom, setNom] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [pwdMsg, setPwdMsg] = useState("");

  const handleChange = async () => {
    if (!oldPwd || !newPwd) { setPwdMsg("Remplir les deux champs"); return; }
    try {
      await api.put("/api/auth/me/password",
        { old_password: oldPwd, new_password: newPwd },
        { headers }
      );
      setPwdMsg("✅ Mot de passe modifié !");
      setOldPwd(""); setNewPwd("");
    } catch(e) { setPwdMsg("❌ " + (e.response?.data?.detail || "Erreur")); }
  };

  const token = localStorage.getItem("peak_token");
  const headers = { Authorization: `Bearer ${token}` };

  // Reference stable : le token est relu a l'appel, donc aucune dependance
  // changeante et pas de rechargement en boucle.
  const loadUsers = useCallback(async () => {
    const jeton = localStorage.getItem("peak_token");
    const res = await api.get("/api/auth/users", { headers: { Authorization: `Bearer ${jeton}` } });
    setUsers(res.data.users);
  }, []);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  const createUser = async () => {
    if (!nom || !email || !password) { setMsg("Remplir tous les champs"); return; }
    try {
      await api.post("/api/auth/users", { nom, email, password, role:"directeur" }, { headers });
      setMsg(`✅ Compte ${nom} créé`);
      setNom(""); setEmail(""); setPassword("");
      loadUsers();
    } catch(e) { setMsg("❌ " + (e.response?.data?.detail || "Erreur")); }
  };

  const deleteUser = async (id, name) => {
    if (!window.confirm(`Désactiver le compte de ${name} ?`)) return;
    await api.delete(`/api/auth/users/${id}`, { headers });
    loadUsers();
  };

  const resetPassword = async (id, name) => {
    const np = window.prompt(`Nouveau mot de passe pour ${name} :`);
    if (!np) return;
    await api.put(`/api/auth/users/${id}/password`, { password: np }, { headers });
    setMsg(`✅ Mot de passe de ${name} réinitialisé`);
  };

  return (
    <div style={{
      position:"fixed", inset:0, background:"rgba(0,0,0,.7)",
      display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000,
      padding:"0 16px"
    }}>
      <div style={{
        background:"#111827", border:"1px solid #1e293b",
        borderRadius:16, padding:32, width:"100%", maxWidth:580, maxHeight:"80vh",
        overflow:"auto", boxShadow:"0 25px 50px rgba(0,0,0,.5)"
      }}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24}}>
          <div style={{fontSize:18, fontWeight:700, color:"#f1f5f9"}}>🔐 Gestion des comptes</div>
          <button onClick={onClose} style={{background:"none", border:"none", color:"#64748b", fontSize:20, cursor:"pointer"}}>✕</button>
        </div>

        {/* Créer un compte */}
        <div style={{background:"#1e293b", borderRadius:10, padding:16, marginBottom:24}}>
          <div style={{fontSize:13, fontWeight:700, color:"#94a3b8", marginBottom:12}}>Créer un compte directeur</div>
          <div style={{display:"flex", flexWrap:"wrap", gap:8, marginBottom:8}}>
            {[["Nom", nom, setNom, "text"], ["Email", email, setEmail, "email"], ["Mot de passe", password, setPassword, "password"]].map(([label, val, setter, type]) => (
              <input key={label} type={type} value={val} onChange={e=>setter(e.target.value)}
                placeholder={label} autoComplete="new-password"
                style={{background:"#0f172a", border:"1px solid #334155", borderRadius:6, padding:"8px 10px", color:"#f1f5f9", fontSize:13, outline:"none", flex:"1 1 150px", minWidth:0}}
              />
            ))}
          </div>
          <button onClick={createUser} style={{background:"#2563eb", color:"#fff", border:"none", borderRadius:6, padding:"8px 20px", fontSize:13, fontWeight:600, cursor:"pointer"}}>
            + Créer le compte
          </button>
          {msg && <div style={{marginTop:8, fontSize:12, color: msg.startsWith("✅") ? "#22c55e" : "#ef4444"}}>{msg}</div>}
        </div>

        {/* Liste des comptes */}
        <div style={{fontSize:13, fontWeight:700, color:"#94a3b8", marginBottom:12}}>Comptes actifs ({users.filter(u=>u.actif).length})</div>
        <div style={{display:"flex", flexDirection:"column", gap:8}}>
          {users.filter(u=>u.actif).map(u => (
            <div key={u.id} style={{background:"#1e293b", borderRadius:8, padding:"10px 14px", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
              <div>
                <div style={{fontWeight:600, color:"#f1f5f9", fontSize:13}}>{u.nom} {u.role==="admin" && <span style={{fontSize:10, background:"#2563eb", color:"#fff", borderRadius:4, padding:"1px 6px", marginLeft:4}}>ADMIN</span>}</div>
                <div style={{fontSize:11, color:"#64748b"}}>{u.email} · {u.last_login ? `Dernière connexion: ${new Date(u.last_login).toLocaleDateString("fr-FR")}` : "Jamais connecté"}</div>
              </div>
              {u.role !== "admin" && (
                <div style={{display:"flex", gap:8}}>
                  <button onClick={()=>resetPassword(u.id, u.nom)} style={{background:"#334155", color:"#94a3b8", border:"none", borderRadius:6, padding:"5px 10px", fontSize:11, cursor:"pointer"}}>🔑 Reset</button>
                  <button onClick={()=>deleteUser(u.id, u.nom)} style={{background:"rgba(239,68,68,.1)", color:"#ef4444", border:"none", borderRadius:6, padding:"5px 10px", fontSize:11, cursor:"pointer"}}>✕ Désactiver</button>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Changer mot de passe admin */}
        <div style={{background:"#1e293b", borderRadius:10, padding:16, marginTop:16}}>
          <div style={{fontSize:13, fontWeight:700, color:"#94a3b8", marginBottom:12}}>🔑 Changer mon mot de passe</div>
          <div style={{display:"flex", flexWrap:"wrap", gap:8}}>
            <input type="password" value={oldPwd} onChange={e=>setOldPwd(e.target.value)}
              placeholder="Ancien mot de passe" autoComplete="new-password"
              style={{background:"#0f172a", border:"1px solid #334155", borderRadius:6, padding:"8px 10px", color:"#f1f5f9", fontSize:13, outline:"none", flex:"1 1 150px"}}
            />
            <input type="password" value={newPwd} onChange={e=>setNewPwd(e.target.value)}
              placeholder="Nouveau mot de passe" autoComplete="new-password"
              style={{background:"#0f172a", border:"1px solid #334155", borderRadius:6, padding:"8px 10px", color:"#f1f5f9", fontSize:13, outline:"none", flex:"1 1 150px"}}
            />
            <button onClick={handleChange}
              style={{background:"#2563eb", color:"#fff", border:"none", borderRadius:6, padding:"8px 16px", fontSize:13, fontWeight:600, cursor:"pointer"}}>
              Modifier
            </button>
            {pwdMsg && <div style={{width:"100%", fontSize:12, color: pwdMsg.startsWith("✅") ? "#22c55e" : "#ef4444", marginTop:4}}>{pwdMsg}</div>}
          </div>
        </div>

      </div>
    </div>
  );
}
